import {useCustomQuery} from '@salesforce/commerce-sdk-react'

const useGetSiblingCategoriesRefinements = (id, enable) => {
    return useCustomQuery(
        {
            options: {
                method: 'GET',
                customApiPathParameters: {
                    apiName: 'product-search',
                    apiVersion: 'v1',
                    endpointPath: 'getSiblingCategoriesRefinements'
                },
                parameters: {
                    c_cgid: id
                }
            }
        },
        {
            enabled: enable
        }
    )
}

export default useGetSiblingCategoriesRefinements
